import { addCallback } from '../lib/teact/teactn';
import type { GlobalState } from '../global/types';
import { selectForensicSettings } from '../global/selectors/forensic';
import { deferRasiHeavyWork, shouldPauseRasiBackgroundWork } from '../rasitech/rasitechPerf';
import { ingestFromGlobal } from './ingest';

let lastIngestAt = 0;
const INGEST_INTERVAL_MS = 60_000;
const MAX_CHATS_INGEST = 4;
let ingestScheduled = false;

export function initForensicAutoIngest() {
  addCallback((global: GlobalState) => {
    const { autoIngest } = selectForensicSettings(global);
    if (!autoIngest) return;
    if (shouldPauseRasiBackgroundWork(global)) return;

    const now = Date.now();
    if (now - lastIngestAt < INGEST_INTERVAL_MS) return;
    if (ingestScheduled) return;

    ingestScheduled = true;
    lastIngestAt = now;

    const chatIds = (global.chats.listIds.active || []).slice(0, MAX_CHATS_INGEST);
    const snapshot = global;

    deferRasiHeavyWork(() => {
      ingestScheduled = false;
      void ingestFromGlobal(snapshot, chatIds.length ? chatIds : undefined);
    });
  });
}
